import React, { useState, useEffect, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { shallowEqual } from 'react-redux';

import styles from './index.module.scss';
import Header from '../../components/Header';
import NavigationMenu from '../../components/NavigationMenu';
import { selectCurrentStore, selectCurrentStoreSettingsSetup } from '../../store/store/selectors';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import useLanguageOptions from '../../data/language/useLanguageOptions';
// import { useLocaleContext } from '../LocaleProvider';
import { logout } from '../../utils/logout';
import { clearUser } from '../../store/user/slice';
// import { useUserSettings } from '../../hooks/useUserSettings';
import { LanguagesDialog } from '@linetweet/linetweet-ui';
import { IMenuLocaleSelectContext } from '@linetweet/linetweet-ui/components/Header/types';
import { LocaleSelectContext } from 'layouts/LocaleProvider/LocaleProvider';

const DashboardWrapper = () => {
  const showNavigationMenuFromStorage = localStorage.getItem('showNavigationMenu');
  const [showNavigationMenu, setShowNavigationMenu]
    = useState<boolean>(typeof showNavigationMenuFromStorage === 'string'
    ? JSON.parse(showNavigationMenuFromStorage)
    : false);
  const [isLanguageDialogOpen, setIsLanguageDialogOpen] = useState<boolean>(false);
  const currentStore = useAppSelector(selectCurrentStore, shallowEqual);
  const storeSettingsSetup = useAppSelector(selectCurrentStoreSettingsSetup);
  const userSettings = useAppSelector((state) => state.user.settings);

  const languageOptions = useLanguageOptions();
  const localeContext = useContext(LocaleSelectContext);
  const dispatch = useAppDispatch();

  useEffect(() => {
    localStorage.setItem('showNavigationMenu', showNavigationMenu.toString());
  }, [showNavigationMenu]);

  const handleSignOut = () => {
    logout();
    dispatch(clearUser());
  };

  return (
    <>
      <Header
        openNavigationMenu={() => setShowNavigationMenu(!showNavigationMenu)}
        urls={{
          diwa: userSettings?.urls?.operations,
          booking: userSettings?.urls?.appointments,
          settings: userSettings?.urls?.settingsPage,
        }}
      />
      <Box className={styles.dashboardWrapper}>
        <NavigationMenu
          storeData={currentStore}
          storeSettingsSetup={storeSettingsSetup}
          show={showNavigationMenu}
          onOpenLanguagesDialog={() => setIsLanguageDialogOpen(true)}
          onSignOut={handleSignOut}
        />
        <Box className={styles.content}>
          <Outlet />
        </Box>
      </Box>
      {isLanguageDialogOpen && (
        <LanguagesDialog
          onClose={() => setIsLanguageDialogOpen(false)}
          localeContext={localeContext as IMenuLocaleSelectContext}
          languageOptions={languageOptions}
        />
      )}
    </>
  );
};

export default DashboardWrapper;
